import { forwardRef } from 'react';
import SelectInternal from './select-internal';
var Select = forwardRef(SelectInternal);
export default Select;
